import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast'
import { deleteUser as deleteUserAPI} from 'services/apiUsers'

const useDelete = () => {

    const queryClient = useQueryClient()
    const{isPending: isDeleting, isSuccess: isDeleted, mutate: deleteUser}=useMutation({
        mutationFn: deleteUserAPI,
        onSuccess:(data)=>{
            console.log("deleted user",data?.user_id || '')
            queryClient.invalidateQueries({queryKey:["userList"]});
            toast.success("User Sucessfully Deleted");
        },
        onError:(error)=>{
            console.log("Error occurred add users",error)
            if (error?.data && typeof error.data === 'object') {
                 // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
        }
        
    })

    return{isDeleting, isDeleted, deleteUser}
}

export default useDelete